import { injectable } from "inversify";

import * as Api from "../constants/ApiUrlConstants"
import { ModelBase } from "../models/ModelBase";
import { SupportoModel } from "../models/SupportoModel";
import container from "../wires/Bootstrapper";
import SERVICE_IDENTIFIER from "../wires/Identifiers";

import { IApiService } from "./shared/ApiService";
import { IApiServiceExt } from "./shared/ApiServiceExt";


export interface ISupportoService  {
    InviaRichiesta(message: string): Promise<ModelBase>
    RenderSupporto(): Promise<SupportoModel>
    DownloadStaticFile(fileName:string)
}

@injectable()
export class SupportoService implements ISupportoService {

    apiService: IApiService
    apiServiceExt: IApiServiceExt

    constructor() {
        this.apiService = container.get(SERVICE_IDENTIFIER.API_SERVICE)
        this.apiServiceExt = container.get(SERVICE_IDENTIFIER.API_SERVICE_EXT)
    }

    // non penso serva - era in tpocket
    //getProviderName(): string {
    //    return PROVIDERS_REGISTRATION.SUPPORTO;
    //}

    async RenderSupporto(): Promise<SupportoModel> {
        return this.apiService.getAsync<SupportoModel>(Api.SupportoRenderSupporto,null);
    }

    async DownloadStaticFile(fileName: string): Promise<SupportoModel> {
        let url = Api.SupportoGetStaticFile + "?fileName="+ fileName
        return this.apiService.downloadFileToken(url)
    }

    async InviaRichiesta(message: string): Promise<ModelBase> {
        return this.apiService.postAsync<ModelBase>(Api.SupportoInviaRichiesta, { Richiesta: message });
    }
}